import React from 'react';
import { motion } from 'framer-motion';
export const PullQuote = () => {
  return <motion.section initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="w-full max-w-4xl mx-auto px-6 py-20 my-12" data-id="element-138">
      <div className="relative p-8 md:p-16 rounded-2xl bg-cosmic-800/50 border border-amber-500/20 shadow-2xl overflow-hidden" data-id="element-139">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-amber-500/10 blur-[50px] rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-140" />
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-amber-500/10 blur-[50px] rounded-full translate-x-1/2 translate-y-1/2" data-id="element-141" />

        <div className="relative z-10 flex flex-col items-center text-center" data-id="element-142">
          <span className="text-6xl md:text-8xl font-serif text-amber-500/30 leading-none h-10 md:h-16 block mb-4" data-id="element-143">
            "
          </span>
          <blockquote className="text-2xl md:text-4xl font-serif italic text-amber-100 leading-snug md:leading-tight mb-8" data-id="element-144">
            No fue una visión. No fue un sueño. Era más real que cualquier cosa
            que hubiera llamado realidad — y cuando regresé, nada de cómo me
            movía por la vida volvió a ser igual.
          </blockquote>
          <cite className="text-lg md:text-xl text-amber-400/80 font-serif not-italic tracking-widest uppercase" data-id="element-145">
            — Del Capítulo 4: El Viaje Molecular
          </cite>
        </div>
      </div>
    </motion.section>;
};